/* eslint-disable max-len */

// Иконка разлогина
export const LogoutIcon = () => {
  const renderContent = () => (
    <svg width='16' height='18' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M3 15H9C9.55206 14.9994 9.99945 14.5521 10 14V12.5H9V14H3V2H9V3.5H10V2C9.99945 1.44794 9.55206 1.00055 9 1H3C2.44794 1.00055 2.00055 1.44794 2 2V14C2.00055 14.5521 2.44794 14.9994 3 15ZM10.293 10.293L12.086 8.5H5V7.5H12.086L10.293 5.707L11 5L14 8L11 11L10.293 10.293Z' fill='#86868A' />
    </svg>
  );

  return renderContent();
};
